import {
  Box,
  CircularProgress,
  Typography,
} from '@mui/material';

import React, {
  useEffect,
  useState,
} from 'react';

import { useNavigate } from 'react-router-dom';

import {
  JSONContent,
} from '@tiptap/react';

import AdminArticleForm, {
  ArticleFormData,
} from './components/AdminArticleForm';

import { useCreateArticle } from './hooks/useCreateArticle';
import { calculateReadingTime } from './helpers/article.helpers';

const emptyContent: JSONContent = {
  type: 'doc',
  content: [
    {
      type: 'paragraph', // Le aseguramos un bloque inicial al editor
    }
  ],
};

export default function AdminNewArticle() {
  const navigate = useNavigate();
  const { createArticle, loading } = useCreateArticle();

  const [isInitializing, setIsInitializing] =
    useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsInitializing(false);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (
    data: ArticleFormData,
    imageFile: File | null,
    translationsPayload?: any[]
  ) => {
    try {
      const esTranslation = translationsPayload?.find(
        (t) => String(t.idioma).toUpperCase() === "ES",
      );
      const readingTime = calculateReadingTime(
        esTranslation?.contenido ?? data.content,
      );

      const payload = {
        categoriaId: Number(data.category),
        grupoArticulo: data.type,
        estado: data.status as 'PUBLICADO' | 'BORRADOR' |'EN_REVISION' | 'APROBADO',
        tiempoDeLectura: readingTime,
        traducciones: translationsPayload || [
          {
            idioma: 'ES',
            titulo: data.title,
            resumen: data.resumen,
            contenido: data.content,
          },
        ],
        portada: imageFile || undefined,
      };

      await createArticle(payload);

      navigate('/admin/articulos');
    } catch (error) {
      console.error('Error al crear el artículo:', error);
      throw error;
    }
  };

  if (isInitializing) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '60vh',
          gap: 2,
        }}
      >
        <CircularProgress
          size={48}
          sx={{
            color: 'primary.main',
          }}
        />

        <Typography
          variant="h6"
          color="text.secondary"
        >
          Cargando...
        </Typography>
      </Box>
    );
  }

  return (
    <AdminArticleForm
      initialData={{
        title: '',
        category: '',
        type: '',
        status: '',
        resumen: '',
        content: emptyContent,
      }}
      onSubmit={handleSubmit}
      loading={loading}
      isEdit={false}
    />
  );
}